import { useTitle } from '../hooks';
import { CssBaseline, Box, Paper } from '@mui/material';
import { Copyright, Grid } from '../components/common';
import sidePhoto from '../assets/pictures/loginSidePhoto.jpg';

export default function AuthorizationPage(props) {
  useTitle(props.title);
  return (
    <Grid container component="main" sx={{ height: '100vh' }}>
      <CssBaseline />
      <Grid backgroundImage item xs={false} sm={4} md={7} image={sidePhoto} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Box
          sx={{
            px: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {props.form && <props.form documentTitle={props.titleSubmitted} />}
          <Box
            sx={{
              mt: 8,
              p: 0,
            }}
          >
            <Copyright />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
